<template>

  <teleport to="body">
    <div v-if="isConfirm" class="modal">
      <div class="confirm-content">
	<div v-if="message=='upload'" class="confirm-message">
	  <img src="/warning.png" class="warning">
	  The file you are uploading may be incorrect.<br>
	  Are you sure you want to upload it?
	</div>
	<div v-if="message=='del'" class="confirm-message">
	  Are you sure you want to delete the selected item?
	</div>
	<div v-if="message=='realdel'" class="confirm-message">
	  <img src="/warning.png" class="warning">
	  Are you sure you want to delete the selected item?<br>
	  This operation will completely remove your data from the system.
	</div>
	<div v-if="message=='rm'" class="confirm-message">
          Are you sure you want to remove the uploaded firmware file?
        </div>
	<div v-if="message=='release'" class="confirm-message">
	  Are you sure you want to release the following information?<br>
	  Model: {{model}}<br>
	  Latest Version: {{version}}
	</div>
	<div class="confirm-buttons">
	  <button @click="go" class="greenbtnM confirm-button1">Yes</button>
	  <button @click="cancel" class="greenbtnM confirm-button2">No</button>
	</div>
      </div>
    </div>
  </teleport>
  
</template>

<script>
import { ref, defineComponent } from 'vue';
import router from '../router';

const isConfirm = ref(false);
const confirmCont = ref(null);
const confirmNo   = ref(null);
const message = ref('del');
const model = ref('');
const version = ref('');
const event = ref(null);

export const confirm = (cont) => {
    message.value = 'del';
    confirmCont.value = cont;
    confirmNo.value = null;
    isConfirm.value = true;
};
	
export const confirmRealDel = (cont) => {
    message.value = 'realdel';
    confirmCont.value = cont;
    confirmNo.value = null;
    isConfirm.value = true;
};
	
export const confirmRemove = (cont) => {
    message.value = 'rm';
    confirmCont.value = cont;
    confirmNo.value = null;
    isConfirm.value = true;
};
	
export const confirmUpload = (cont,no) => {
    message.value = 'upload';
    confirmCont.value = cont;
    confirmNo.value   = no;
    isConfirm.value = true;
};

export const confirmRelease = (ev,m,v,cont) => {
    event.value = ev;
    message.value = 'release'
    model.value = m;
    version.value = v;
    confirmCont.value = cont;
    confirmNo.value = null;
    isConfirm.value = true;
}
	
export default defineComponent({
    setup() {

	isConfirm.value = false;
    
	const cancel = () => {
	    isConfirm.value = false;
	    if (confirmNo.value) {
	        confirmNo.value();
	    }
	};

	const go = () => {
	    isConfirm.value = false;
	    if (confirmCont.value) {
	        let ev = event.value;
		event.value = null;
		confirmCont.value(ev);
	    }
	};

	return {
	    message,
	    model,
	    version,
	    isConfirm,
	    confirmCont,
	    confirmNo,
	    cancel,
	    go,
	}
    }
});

</script>

<style scoped>
.modal {
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    background-color: rgba(0,0,0,.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.confirm-content {
    display: flex;
    flex-direction: column;
    background-color: white;
    width: 300px;
}
.confirm-title {
    width: 100%;
    font-weight: bold;
}
.confirm-message {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
}
.confirm-button {
    display: flex;
    justify-content: center;
    margin-right: 2px;
    margin-bottom: 2px;
}
.warning {
    width: 40px;
    height: 40px;
}
</style>
